<template>
  <div :class="shown ? 'trash-item trash-2 show' : 'trash-item trash-2'">
    <div class="img-ct">
      <img :src="depositTypeImage('battery')" alt="">
    </div>
    <div class="trash-specs">
      <div class="name">{{ $t('item_battery') }}</div>
      <div class="trash-value">+ {{ value }} <small>{{ $t('item_points') }}</small></div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  props: ["shown", "value"],
  computed: {
    ...mapGetters('DepositTypes', ['depositTypeImage']),
  },
}
</script>
